{
    "producedComponentList": [],
    "producedTotalCount": 0,
    "producedErrorsCount": 0,
    "producedSortExpression": null,
    "producedFilterExpression": null,

    "allocatedComponentList": [],
    "allocatedTotalCount": 0,
    "allocatedErrorsCount": 0,
    "allocatedSortExpression": null,
    "allocatedFilterExpression": null,

    "stockComponentList": [],
    "stockTotalCount": 0,
    "stockErrorsCount": 0,
    "stockSortExpression": null,
    "stockFilterExpression": null,

    "producedPaging": { "offset": 50, "page": 1 },
    "allocatedPaging": { "offset": 50, "page": 1 },
    "stockPaging": { "offset": 50, "page": 1 },

    "producedWidget": {
        "totalValue": 0,
        "totalAmount": 0
    },
    "allocatedWidget": {
        "totalValue": 0,
        "totalAmount": 0
    },
    "stockWidget": {
        "totalValue": 0,
        "totalAmount": 0
    }
}